import useLanguage from './hooks/useLanguage';
import i18n from 'i18next';
import {lazy, Suspense, useEffect} from 'react';
import {BrowserRouter, Route, Routes} from 'react-router-dom';
import {LoginMBIDPage} from './pages/login/LoginMBIDPage';
import {LoginNoBankIdPage} from './pages/login/LoginNoBankIdPage';
import {LoginNoBankIdCallbackPage} from './pages/login/LoginNoBankIdCallbackPage';
import {LoginMBIDError} from './pages/error/LoginMBIDError';
import {SigningMBIDPage} from './pages/signing/SigningMBIDPage';
import {LoginDemoMainPage} from './pages';
import {LoginDemo} from './pages/demo/LoginDemo';
import {LoginDemoHome} from './pages/demo/LoginDemoHome';
import {LoginDemoAuthenticationCallback} from './pages/demo/LoginDemoAuthenticationCallback';
import {SigningDemo} from './pages/demo/SigningDemo';
import {ResursLoading} from './components';

// Lazy-loaded: pulls in pdfjs-dist, which adds ~340kB (gzip ~100kB) to
// whichever bundle imports it. Only reached via digital-id-service's bounce
// redirect, for a normal-signing session created with its (dev-only,
// non-prod) provider_override=SE_MBID override on POST /signing — see
// EID-567 — so there's no reason for every BankID login/signing user to pay
// for it upfront.
const DocumentsPage = lazy(() =>
  import('./pages/documents/DocumentsPage').then((m) => ({
    default: m.DocumentsPage,
  })),
);

export const AppRouter = () => {
  return (
    <BrowserRouter>
      <ChangeLanguage />
      <Routes>
        <Route path="/demo" element={<LoginDemo />} />
        <Route path="/demo-home" element={<LoginDemoHome />} />
        <Route path="/demo-main/*" element={<LoginDemoMainPage />} />
        <Route
          path="/demo-auth"
          element={<LoginDemoAuthenticationCallback />}
        />
        <Route path="/login/mbid" element={<LoginMBIDPage />} />
        <Route path="/login/no-bankid" element={<LoginNoBankIdPage />} />
        <Route
          path="/login/no-bankid/callback"
          element={<LoginNoBankIdCallbackPage />}
        />
        <Route path="/login/error" element={<LoginMBIDError />} />
        <Route path="/sign/mbid" element={<SigningMBIDPage />} />
        <Route
          path="/sign/documents"
          element={
            <Suspense fallback={<ResursLoading />}>
              <DocumentsPage />
            </Suspense>
          }
        />
        <Route path="/demo-signing" element={<SigningDemo />} />
      </Routes>
    </BrowserRouter>
  );
};

const languages = ['sv', 'da', 'nb', 'fi', 'en'] as const;
const ChangeLanguage = () => {
  const lang = useLanguage();
  useEffect(() => {
    const parameters = new URLSearchParams(window.location.search);
    const param = parameters.get('lang');
    const language = languages.find((e) => e === param);
    if (!language) return;
    i18n.changeLanguage(language);
    lang.setValue(language);
  }, [lang]);
  return null;
};
